// extracted by mini-css-extract-plugin
export default {"tableWrapper":"AdminOrganization_tableWrapper__X2Vc+"};